<template>
  <div>
    <ul>
      <li class="border p-5">
        <b>{{ $t('corporate.title') }}</b>
      </li>
      <li v-for="(item, index) in listItems" :key="item.name">
        <nuxt-link
          v-if="item.show"
          :to="menuItemUrl(item)"
          class="p-5 border block border-t-0"
          :class="{
            'nuxt-link-exact-active': currentPathName === 'kurumsal-index' && !index,
            'nuxt-link-active': currentPathName === 'kurumsal-index' && !index,
          }"
        >
          {{ item.name }}
        </nuxt-link>
      </li>
      <li id="social-media-container" class="p-4 flex flex-wrap border border-t-0 mb-4">
        <b class="ml-1">{{ $t('corporate.social-media') }}</b>
        <div class="my-4 ml-1 w-full">{{ $t('corporate.like-follow') }}</div>
        <a
          v-for="item in socialMediaAccounts.filter((acc) => acc.name !== 'Whatsapp')"
          :key="item.name"
          target="_blank"
          :href="item.link"
          :class="`w-12 h-12 flex items-center justify-center m-1 ${item.class ? item.class : ''}`"
          :style="{ backgroundColor: item.background }"
        >
          <ORawIcon v-if="item.icon === 'instagram'" :icon="`article/${item.icon}`" svg-class="w-5 h-5 text-white" />
          <ORawIcon v-else :icon="`article/${item.icon}`" svg-class="w-4 h-4 text-white" />
        </a>
      </li>
    </ul>
    <div class="flex items-center justify-evenly">
      <OIcon icon="onedio" svg-class="w-24 h-8 text-alpha-90" />
      <span class="text-gray-400 text-sm">Copyright © {{ year }}</span>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, useRoute, useContext } from '@nuxtjs/composition-api';
import { normalizeText } from '~/modules/common/utils/stringUtils';
import { socialMediaAccounts } from '~/modules/common/components/app/header/headerUtils';
import { OIcon, ORawIcon } from '~/modules/common/components/ui';
import {
  CORPORATE_PATH,
  ABOUT_PATH,
  CONTACT_PATH,
  CAREER_PATH,
  MASTHEAD_PATH,
  COOKIE_POLICY_PATH,
  PRIVACY_POLICY_PATH,
  USER_AGREEMENT_PATH,
  PUBLICATION_PRINCIPLES_PATH,
  COMMUNITY_RULES_PATH,
  IS_ONEDIO,
  IS_CO,
} from '~/constants/config';

export default defineComponent({
  components: { OIcon, ORawIcon },
  setup() {
    const route = useRoute();
    const { i18n } = useContext();
    const currentPathName = computed(() => route.value.name);
    const listItems = [
      {
        name: i18n.t('corporate.about-us'),
        path: ABOUT_PATH,
        show: IS_ONEDIO,
      },
      {
        name: i18n.t('corporate.contact'),
        path: CONTACT_PATH,
        show: IS_ONEDIO,
      },
      {
        name: i18n.t('corporate.career'),
        path: CAREER_PATH,
        show: true,
      },
      {
        name: i18n.t('corporate.cookie-policy'),
        path: COOKIE_POLICY_PATH,
        show: IS_ONEDIO,
      },
      {
        name: i18n.t('corporate.privacy-policy'),
        path: PRIVACY_POLICY_PATH,
        show: IS_ONEDIO || IS_CO,
      },
      {
        name: i18n.t('corporate.user-agreement'),
        path: USER_AGREEMENT_PATH,
        show: IS_ONEDIO,
      },
      {
        name: i18n.t('corporate.publication-principles'),
        path: PUBLICATION_PRINCIPLES_PATH,
        show: IS_ONEDIO,
      },
      {
        name: i18n.t('corporate.community-rules'),
        path: COMMUNITY_RULES_PATH,
        show: IS_ONEDIO,
      },
      {
        name: i18n.t('corporate.masthead'),
        path: MASTHEAD_PATH,
        show: IS_ONEDIO,
      },
    ];

    const menuItemUrl = (item) => {
      if (item.path === COOKIE_POLICY_PATH) {
        return '/' + item.path;
      } else {
        return `/${CORPORATE_PATH}/` + item.path;
      }
    };
    const year = new Date().getFullYear();

    return {
      currentPathName,
      listItems,
      menuItemUrl,
      socialMediaAccounts,
      normalizeText,
      year,
    };
  },
});
</script>
